import React from "react";
import { Link } from "gatsby";
import { StaticImage } from 'gatsby-plugin-image';

import {
    doFlex,
    container,
    knowmoreSection,
    knowmoreText,
    flexColumn,
    knowmoreButton,
    padT40,
    knowmoreImg,
    knowmoreLink,
    knowmoreHead,
} from './main.module.scss'

const Knowmore = () => {
    return (
        <div className={`${knowmoreSection}`}>
            <div className={`${doFlex} ${container}`}>
                <div className={`${doFlex} ${flexColumn} ${knowmoreText}`}>
                    <h2 className={`${knowmoreHead}`}>Need to Know More?</h2>
                    <p>‘’Experience prompt and friendly assistance from our knowledgeable support team. We're ready to help you with any questions, technical issues, or guidance you may need.”</p>
                    <div className={padT40}>
                        <Link to="/contact-us"><button className={`${knowmoreButton}`}>Contact Us</button></Link>
                        <a href="https://bigboxhost.com/portal/submitticket.php?step=2&deptid=2" className={knowmoreLink}>Open support ticket</a>
                    </div>
                </div>
                <div className={knowmoreImg}>
                    <StaticImage src="../images/knowmoreimg.png" alt="BigBox Support" layout="constrained" quality="100" />
                </div>
            </div>
        </div>
    );
}

export default Knowmore